import React, { useEffect, useState } from "react";
import { APISD } from "../../../../../../../../config/apisd";

const STUDENT_DETAIL_TABS = [
  { 
    title: "Data Pribadi", 
    sections: [
      { 
        title: "Identitas Siswa", 
        fields: [
          ["Nama lengkap", ["nama_lengkap", "nama_siswa", "name_student"]], 
          ["Panggilan", "nama_alias"], 
          ["Tahun ajaran", ["tahun_ajaran", "name_year"]],
          ["NIS", "nis_ypi"], 
          ["NISN", "nisn"], 
          ["Jenis Kelamin", ["jenis_kelamin", "gender"]],
          ["Tempat lahir", "tempat_lahir"], 
          ["Tanggal lahir", "tanggal_lahir_siswa"],
          ["Agama", "agama"], 
          ["Kewarganegaraan", "kewarnegaraan"], 
          ["Anak ke", ["anak_ke", "anak_ke-"]],
          ["NIK", "nik"], 
          ["No. akte kelahiran", null], 
          ["No. KK", "no_kk"], 
          ["Email sekolah", ["email_siswa", "email_murid"]], 
          ["Email belajar.id", null],
          ["Jumlah saudara kandung", "jumlah_saudara_kandung"], 
          ["Jumlah saudara tiri", null],
          ["Status anak", null], 
          ["Bahasa di rumah", "bahasa_dirumah"], 
          ["Golongan darah", null],
          ["Lingkar kepala", "linkar_kepala"],
          
          
          
          ["Berat badan", "berat"], 
          ["Tinggi badan", "tinggi"],
        ]
      }
    ]
  },
  { 
    title: "Alamat", 
    sections: [
      { 
        title: "Alamat di KK", 
        fields: [
          ["Alamat", ["alamat_lengkap_kk", "alamat_lengkap"]], 
          ["RT", null], ["RW", null], 
          ["Desa/Kelurahan", ["desa_kelurahan_kk", "kelurahan"]],
          ["Kecamatan", "kecamatan_kk"], 
          ["Kode pos", "kode_pos_kk"], 
          ["Kabupaten/Kota", ["kota_kabupaten_kk", "kota"]], 
          ["Provinsi", "provinsi"],
        ] 
      },
      { 
        title: "Alamat Saat Ini", 
        fields: [
          ["Alamat", null], 
          ["Kelurahan", null], 
          ["Kecamatan", null], 
          ["Kabupaten/Kota", null],
          ["Kode pos", null], 
          ["Tinggal bersama", null], 
          ["Jarak ke sekolah", "jarak_rumah_sekolah"],
          
          
        ]
      },
    ] 
  },
  { 
    title: "Pendidikan", 
    sections: [
      { 
        title: "Pendidikan Sebelumnya", 
        fields: [
          ["Sekolah asal", ["sekolah_asal", "nama_sekolah_asal"]],
          
          
          
          
          
          
           
          ["Tanggal ijazah", null], 
          ["No. ijazah", null], 
          ["Lama belajar", null]
        ] 
      },
      { 
        title: "Pindahan/Mutasi Masuk", 
        fields: [
          ["Dari sekolah", null], 
          ["Alasan", null]
        ] 
      },
      { 
        title: "Status Murid", 
        fields: [
          ["Status murid", ["keterangan_status", "status_label"]],
          ["Tanggal nonaktif", "tanggal_nonaktif"],
          ["Keterangan nonaktif", "keterangan_nonaktif"]
        ] 
      },
      { 
        title: "Diterima di Sekolah Ini", 
        fields: [
          ["Di kelas", "name_grade"], 
          ["Tanggal", null]
        ] 
      },
    ] 
  },
  { 
    title: "Informasi Orang Tua", 
    sections: [
      { 
        title: "Ayah", 
        fields: [
          ["Nama", "nama_lengkap_ayah"], 
          
          ["Tanggal lahir", "tanggal_lahir_ayah"],
          
           
          ["Pendidikan terakhir", "pendidikan_terakhir_ayah"], 
          ["Pekerjaan", "pekerjaan_ayah"], 
          ["Penghasilan", "penghasilan_ayah"], 
          ["NIK", "nik_ayah"], 
          ["Kontak", "no_handphone_ayah"], 
          ["Keadaan", "keterangan_ayah"]
        ] 
      },
      { 
        title: "Ibu", 
        fields: [
          ["Nama", "nama_lengkap_ibu"], 
          
          ["Tanggal lahir", "tanggal_lahir_ibu"],
          
           
          ["Pendidikan terakhir", null], 
          ["Pekerjaan", "pekerjaan_ibu"], 
          ["Penghasilan", "penghasilan_ibu"], 
          ["NIK", "nik_ibu"], 
          ["Kontak", "no_handphone_ibu"], 
          ["Keadaan", "keterangan_ibu"]
        ] 
      },
    ] 
  },
  { 
    title: "Perkembangan Peserta Didik", 
    sections: [
      { 
        title: "Perkembangan Peserta Didik", 
        fields: [
          ["Beasiswa", null], 
          ["Pindah sekolah (tanggal)", null], 
          ["Alasan", null], 
          ["Sekolah tujuan", null],
          
          
          
          
          
          
          
          
        ] 
      }
    ] 
  },
];

// Kolom yang belum punya key API memakai key lokal sementara.
const FIELD_KEYS = {
  "Identitas Siswa:No. akte kelahiran": "no_akte_kelahiran",
  "Identitas Siswa:Email belajar.id": "email_belajar_id",
  "Identitas Siswa:Jumlah saudara tiri": "jumlah_saudara_tiri",
  "Identitas Siswa:Status anak": "status_anak",
  "Identitas Siswa:Golongan darah": "golongan_darah",
  "Alamat di KK:RT": "rt_kk",
  "Alamat di KK:RW": "rw_kk",
  "Alamat Saat Ini:Alamat": "alamat",
  "Alamat Saat Ini:Kelurahan": "desa_kelurahan",
  "Alamat Saat Ini:Kecamatan": "kecamatan",
  "Alamat Saat Ini:Kabupaten/Kota": "kota_kabupaten",
  "Alamat Saat Ini:Kode pos": "kode_pos",
  "Alamat Saat Ini:Tinggal bersama": "tinggal_bersama",
  "Pendidikan Sebelumnya:Tanggal ijazah": "tanggal_ijazah",
  "Pendidikan Sebelumnya:No. ijazah": "no_ijazah",
  "Pendidikan Sebelumnya:Lama belajar": "lama_belajar",
  "Pindahan/Mutasi Masuk:Dari sekolah": "pindahan_dari_sekolah",
  "Pindahan/Mutasi Masuk:Alasan": "alasan_mutasi_masuk",
  "Diterima di Sekolah Ini:Tanggal": "tanggal_diterima",
  "Ibu:Pendidikan terakhir": "pendidikan_terakhir_ibu",
  "Perkembangan Peserta Didik:Beasiswa": "beasiswa",
  "Perkembangan Peserta Didik:Pindah sekolah (tanggal)": "tanggal_pindah_sekolah",
  "Perkembangan Peserta Didik:Alasan": "alasan_pindah_sekolah",
  "Perkembangan Peserta Didik:Sekolah tujuan": "sekolah_tujuan",
};

const getFieldKey = (section, label, field) =>
  (Array.isArray(field) ? field[0] : field) || FIELD_KEYS[`${section}:${label}`];

// Biodata berasal dari respons GET /api/student-kelas yang sudah dimuat di tabel.
export default function StudentDetailModal({ student, onClose, onSave }) {
  const [activeTab, setActiveTab] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState({});
  const [savedValues, setSavedValues] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  useEffect(() => {
    setActiveTab(0);
    setIsEditing(false);
    setDraft({});
    setSavedValues({});
    setSaveError("");
  }, [student]);

  useEffect(() => {
    if (!student) return undefined;
    const onEscape = (event) => {
      if (event.key === "Escape" && !isSaving) onClose();
    };
    document.addEventListener("keydown", onEscape);
    return () => document.removeEventListener("keydown", onEscape);
  }, [student, onClose, isSaving]);

  if (!student) return null;

  const source = { ...student, ...(student.biodata || {}) };
  const valueFor = (key, field) => {
    if (Object.prototype.hasOwnProperty.call(draft, key)) return draft[key];
    if (Object.prototype.hasOwnProperty.call(savedValues, key)) return savedValues[key];
    const keys = Array.isArray(field) ? field : [key];
    for (const candidate of keys) {
      const value = source[candidate];
      if (value !== null && value !== undefined && value !== "") return value;
    }
    return "";
  };

  const handleSave = async () => {
    setSaveError("");
    setIsSaving(true);

    try {
      const studentId = student?.ysb_student_id ?? student?.id;

      if (!studentId) {
        throw new Error("ID siswa tidak ditemukan.");
      }

      // Kirim hanya field yang benar-benar diubah oleh user.
      // Endpoint biodata menggunakan ID siswa pada URL.
      if (Object.keys(draft).length > 0) {
        const token = localStorage.getItem("token");
        await APISD.put(
          `/api/student-kelas/biodata/${studentId}`,
          draft,
          {
            headers: {
              Authorization: `${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      }

      const nextValues = { ...source, ...savedValues, ...draft };

      // Tetap dukung callback induk untuk sinkronisasi data tabel/toast bila disediakan.
      if (onSave) await onSave(nextValues, student, draft);

      setSavedValues(nextValues);
      setDraft({});
      setIsEditing(false);
    } catch (error) {
      setSaveError(
        error?.response?.data?.message ||
        error?.message ||
        "Perubahan gagal disimpan. Coba lagi."
      );
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
    <div 
      className="student-detail-overlay" 
      onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}
    >
      <div 
        className="student-detail-modal" 
        role="dialog" 
        aria-modal="true" 
        aria-label="Detail siswa"
      >
        <div className="student-detail-header">
          <div>
            <h5>Detail Siswa</h5>
            <p>{isEditing ? "Ubah data siswa pada kolom di bawah" : (source.nama_lengkap || source.nama_siswa || "Informasi lengkap siswa")}</p>
          </div>

          <button 
            type="button" 
            className="student-detail-close" 
            onClick={onClose} 
            aria-label="Tutup detail">
              ×
          </button>
        </div>

        <div 
          className="student-detail-tabs" 
          role="tablist" 
          aria-label="Jenis informasi siswa"
        >
          {STUDENT_DETAIL_TABS.map((tab, index) => (
            <button 
            key={tab.title} 
            type="button" 
            role="tab" 
            aria-selected={activeTab === index} 
            className={activeTab === index ? "is-active" : ""} 
            onClick={() => setActiveTab(index)}
            >
              {tab.title}
            </button>
          ))}
        </div>

        <div className="student-detail-body" role="tabpanel">
          {STUDENT_DETAIL_TABS[activeTab].sections.map((section) => (
            <section 
              key={section.title} 
              className="student-detail-section"
            >
              <h6>{section.title}</h6>
              <div className="student-detail-grid">
                {section.fields.map(([label, field]) => {
                  const key = getFieldKey(section.title, label, field);
                  const value = valueFor(key, field);
                  const unavailable = value === "" || value === null || value === undefined;
                  return <div className="student-detail-field" key={label}>
                    <span>{label}</span>
                    {isEditing ? (
                      <input
                        type="text"
                        aria-label={label}
                        value={value}
                        placeholder="Isi data siswa"
                        onChange={(event) => setDraft((current) => ({
                          ...current, [key]: event.target.value
                        }))}
                      />
                    ) : (
                      <strong className={unavailable ? "student-detail-unavailable" : undefined}>
                        {unavailable ? "Belum tersedia" : value}
                      </strong>
                    )}
                  </div>;
                })}
              </div>
            </section>
          ))}
        </div>
        <div className="student-detail-footer">
          {saveError && <span role="alert" className="student-detail-error">{saveError}</span>}
          <div className="student-detail-actions">
            {isEditing ? (
              <>
                <button type="button" className="student-detail-secondary" disabled={isSaving}
                  onClick={() => { setDraft({}); setSaveError(""); setIsEditing(false); }}>
                  Batal
                </button>
                <button type="button" disabled={isSaving} onClick={handleSave}>
                  {isSaving ? "Menyimpan..." : "Simpan Perubahan"}
                </button>
              </>
            ) : (
              <>
                <button type="button" className="student-detail-secondary" onClick={onClose}>Tutup</button>
                <button type="button" onClick={() => setIsEditing(true)}>Edit</button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
    <style>{`        .student-detail-overlay { 
          position: fixed; 
          inset: 0; 
          z-index: 1200; 
          background: rgba(15, 23, 42, .55); 
          display: flex;
          justify-content: center; 
          align-items: center; 
          padding: 20px; 
        }
        .student-detail-modal { 
          width: min(100%, 1050px); 
          height: min(80vh, 720px); 
          max-height: 90vh; 
          display: flex; 
          flex-direction: column; 
          background: #fff; 
          border-radius: 16px; 
          overflow: hidden; 
          box-shadow: 0 18px 55px rgba(15, 23, 42, .22); 
          font-size: 13px; 
        }
        .student-detail-header { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          padding: 20px 24px 15px; 
          background: #f3f8fd; 
          border-bottom: 1px solid #dbe7f3; 
        }
        .student-detail-header h5 { 
          margin: 0 0 4px; 
          font-size: 19px; 
          font-weight: 700; 
          color: #3f5bea; 
        }
        .student-detail-header p { 
          margin: 0; 
          color: #64748b; 
        }
        .student-detail-close { 
          border: 0; 
          background: transparent; 
          color: #475569; 
          font-size: 26px; 
          cursor: pointer; 
          line-height: 1; 
        }
        .student-detail-tabs { 
          display: flex; 
          gap: 4px; 
          padding: 10px 18px 0; 
          overflow-x: auto; 
          flex-shrink: 0; 
          border-bottom: 1px solid #dbe7f3; 
        }
        .student-detail-tabs button { 
          background: transparent; 
          border: 0; 
          border-bottom: 3px solid transparent; 
          padding: 11px 13px; 
          white-space: nowrap; 
          color: #64748b; 
          font-size: 13px; 
          font-weight: 600; 
          cursor: pointer; 
        }
        .student-detail-tabs button.is-active { 
          color: #3f5bea; 
          border-bottom-color: #3f5bea; 
        }
        .student-detail-body { 
          flex: 1; 
          min-height: 0; 
          padding: 22px 24px 32px; 
          overflow-y: auto; 
          background: #f8fbff; 
        }
        .student-detail-intro { 
          display: flex; 
          align-items: center; 
          justify-content: space-between; 
          gap: 12px; 
          padding: 18px 20px; 
          margin-bottom: 20px; 
          border: 1px solid #d8e8fa; 
          border-radius: 12px; 
          background: linear-gradient(110deg, #eaf4ff, #fff); 
        }
        .student-detail-intro span:first-child { 
          color: #5984ae; 
          font-size: 10px; 
          letter-spacing: .1em; 
          font-weight: 700; 
        }
        .student-detail-intro h6 { 
          margin: 4px 0 0; 
          color: #3f5bea; 
          font-size: 17px; 
          font-weight: 700; 
        }
        .student-detail-count { 
          padding: 6px 10px; 
          border-radius: 999px; 
          background: #fff; 
          border: 1px solid #cfe3f7; 
          color: #21629d; 
          white-space: nowrap; 
          font-weight: 600; 
        }
        .student-detail-section + .student-detail-section { 
          margin-top: 24px; 
        }
        .student-detail-section h6 { 
          font-size: 14px; 
          font-weight: 700; 
          color: #3f5bea; 
          margin: 0 0 12px; 
          padding-bottom: 8px; 
          border-bottom: 1px solid #e2e8f0; 
        }
        .student-detail-grid { 
          display: grid; 
          grid-template-columns: repeat(3, minmax(0, 1fr)); 
          gap: 12px; 
        }
        .student-detail-field { 
          background: #fff; 
          border: 1px solid #dce7f3; 
          border-radius: 9px; 
          padding: 12px 14px; 
          min-width: 0; 
          box-shadow: 0 2px 7px rgba(18, 67, 111, .035); 
        }
        .student-detail-field span { 
          display: block; 
          color: #64748b; 
          margin-bottom: 5px; 
        }
        .student-detail-field strong { 
          display: block; 
          color: #1e293b; 
          font-weight: 600; 
          overflow-wrap: anywhere; 
        }
        .student-detail-field strong.student-detail-unavailable { 
          display: inline-block; 
          padding: 4px 9px; 
          border-radius: 6px; 
          background: #fdfdfd; 
          color: #9a5b08; 
          font-size: 12px; 
          font-weight: 700; 
        }
        .student-detail-field input {
          width: 100%;
          box-sizing: border-box;
          border: 1px solid #cbd5e1;
          border-radius: 6px;
          padding: 8px 10px;
          font: inherit;
          color: #1e293b;
          outline: none;
        }
        .student-detail-field input:focus {
          border-color: #3f5bea;
          box-shadow: 0 0 0 3px rgba(63, 91, 234, .12);
        }
        .student-detail-footer {
          flex-shrink: 0; 
          padding: 12px 24px; 
          border-top: 1px solid #e2e8f0; 
          background: #fff;
        }
        .student-detail-actions {
          display: flex;
          justify-content: flex-end;
          gap: 8px;
        }
        .student-detail-error {
          display: block;
          color: #b42318;
          margin-bottom: 8px;
        }
        .student-detail-footer button { 
        background: #3f5bea; 
        color: #fff; 
        border: 0; 
        border-radius: 7px; 
        padding: 8px 20px; 
        cursor: pointer; 
        }

        .student-detail-footer button.student-detail-secondary {
          background: #fff;
          color: #3f5bea;
          border: 1px solid #cbd5e1;
        }
        .student-detail-footer button:disabled {
          opacity: .6;
          cursor: not-allowed;
        }

        @media (max-width: 768px) { 
          .student-detail-overlay { 
            padding: 0; 
            align-items: flex-end; 
          } 
          .student-detail-modal { 
            height: 92vh; 
            max-height: 92vh; 
            border-radius: 16px 16px 0 0; 
          } 
          .student-detail-grid { 
            grid-template-columns: repeat(2, minmax(0, 1fr)); 
          } 
        }
          
        @media (max-width: 480px) { 
          .student-detail-grid { 
            grid-template-columns: 1fr; 
          } 
          .student-detail-header, .student-detail-body { 
            padding-left: 16px; 
            padding-right: 16px; 
          } 
        }

`}</style>
    </>
  );
}
